import { put, takeEvery, select } from 'redux-saga/effects';
import { postWithToken, getWithToken } from '../../../api/network';
import {
  appNotify,
  createShape,
  setCreatingNewShape,
  setSelectedGroupId,
  setSelectedGroupIsLoading,
  setErrorListModalState,
  setSelectedModule
} from '../../../store/actions';
import { selectedModuleSelector } from 'store/selectors'; 

export function* createShapeSaga() {
  yield takeEvery(createShape, function* ({ payload }) {
    try {
      yield put(setSelectedGroupIsLoading(true));

      const url = `/api/assumptions/shapes`;
      const res = yield postWithToken(url, payload);
      const newShape = yield res.json();

      yield put(setCreatingNewShape(false));
      yield put(setSelectedGroupIsLoading(false));
      yield put(setSelectedGroupId(payload.groupId, newShape.shapeId));
      yield put(appNotify(`${payload.name} created`, 'success'));

      const selectedModule = yield select(selectedModuleSelector); 
      const moduleUrl = `/api/assumptions/modules/${selectedModule.moduleId}`; 
      const moduleRes = yield getWithToken(moduleUrl); 
      const data = yield moduleRes.json(); 
  
      yield put(setSelectedModule(data)); 

      const missingDetails = newShape.details.filter((detail) => !detail.found);

      if(missingDetails.length > 0) { 
        const missingGeoIds = missingDetails.map(detail => detail.geoId);

        const errorModal = {
          header: `Could not find the following ${payload.level}:`, 
          details: missingGeoIds 
        };
  
        yield put(setErrorListModalState(errorModal));
        yield put(appNotify('Missing Geo IDs', 'error', { showDetailsButton: true }));
      }
    } catch (error) {
      yield put(appNotify(`Failed to create shape: ${error.message}`, 'error'));
      yield put(setSelectedGroupIsLoading(false));
    }
  });
}
